import React from "react";
import { Outlet } from "react-router-dom";
import PermissionRoute from "./PermissionRoute";

/** Layout route: gates all nested routes by RBAC module. */
export default function PermissionLayout({ module }) {
  return (
    <PermissionRoute module={module}>
      <Outlet />
    </PermissionRoute>
  );
}
